import React, { useMemo } from 'react';
import { ChartPie } from './ChartPie';
import { ChartPieComponentProps, Item, TerpeneDataRow } from './types';

const ChartPieTerpenesConcentrations: React.FC<ChartPieComponentProps> = ({ data }) => {
    const filteredItems = useMemo(() =>
            data.items.filter((item: Item<TerpeneDataRow>) => item.HEADER?.startsWith("Concentration of terpenes")),
        [data.items]
    );

    console.log('Filtered Items Terpenes:', filteredItems);

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {filteredItems.map((basketItem, index) => {
                const pieData = (basketItem.DATA as TerpeneDataRow[])
                    .filter((item) => !isNaN(Number(item.CONCENTRATION)))
                    .map(item => ({
                        NAME: item.NAME,
                        VALUE: Number(item.CONCENTRATION)
                    }));

                console.log(`Pie Data for ${basketItem.TITLE || basketItem._id || 'Unknown'}:`, pieData);

                if (pieData.length === 0) return null;

                return (
                    <div key={basketItem._id || index} style={{ marginBottom: '2rem', maxWidth: '250px', marginLeft: '50px' }}>
                        <h5>{`${basketItem.HEADER || 'Concentration of terpenes'} ${basketItem.TITLE || ''}`}</h5>
                        <ChartPie data={pieData} />
                        <h5>[ % dry weight ]</h5>
                    </div>
                );
            })}
        </div>
    );
};

export default ChartPieTerpenesConcentrations;
